import { useState } from "react";
import { ChevronDown, ChevronUp, Database } from "lucide-react";
import type { ThinkingStep } from "../../types/chat";

function TypingDots() {
  return (
    <span className="inline-flex items-center gap-0.5">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="h-2 w-2 rounded-full bg-blue-400"
          style={{ animation: `bounce 1.2s ease-in-out ${i * 0.2}s infinite` }}
        />
      ))}
    </span>
  );
}

interface ThinkingIndicatorProps {
  steps: ThinkingStep[];
  agentName?: string;
}

export default function ThinkingIndicator({ steps, agentName = "AI" }: ThinkingIndicatorProps) {
  const [open, setOpen] = useState(false);
  const latest = steps[steps.length - 1];

  return (
    <div className="flex items-start gap-3">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-semibold text-white shadow-sm">
        {agentName.slice(0, 2).toUpperCase()}
      </div>
      <div className="rounded-2xl bg-white px-4 py-3 text-sm shadow-sm ring-1 ring-gray-100">
        <button
          onClick={() => setOpen((o) => !o)}
          className="flex items-center gap-2 text-gray-500"
        >
          <TypingDots />
          <span>{latest?.explanation || "Thinking..."}</span>
          {steps.length > 0 && (
            open ? <ChevronUp size={12} className="ml-1" /> : <ChevronDown size={12} className="ml-1" />
          )}
        </button>
        {open && latest?.sql && (
          <div className="mt-2 rounded border border-blue-200 bg-blue-50">
            <div className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-blue-700">
              <Database size={12} />
              SQL
            </div>
            <pre className="overflow-x-auto px-3 pb-3 pt-1 text-xs text-gray-700 whitespace-pre-wrap break-words">
              {latest.sql}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
}
